import { View, Text } from "react-native";
import React from "react";

interface FormRowProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
  isFullWidth?: boolean;
}

export function FormRow({
  label,
  children,
  className,
  isFullWidth,
}: FormRowProps) {
  return (
    <View className={` ${isFullWidth ? null : "md:max-w-[70%]"} w-full`}>
      <View className="flex flex-col md:flex-row w-full md:mb-4 ">
        <Text className="w-[200px]  my-3 md:mb-0 text-gray-500 ">{label}</Text>
        <View className={`flex-1 ${className}`}>{children}</View>
      </View>
    </View>
  );
}
